import { render, staticRenderFns } from "./ApelidoPontoField.vue?vue&type=template&id=639f8571&scoped=true&"
import script from "./ApelidoPontoField.vue?vue&type=script&lang=js&"
export * from "./ApelidoPontoField.vue?vue&type=script&lang=js&"
import style0 from "./ApelidoPontoField.vue?vue&type=style&index=0&id=639f8571&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f8571",
  null
  
)

export default component.exports